import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ChartAccountsPropTypes } from './propTypes';
import ChartOfAccountsAdminColumnRenderer from './chartOfAccountsAdminColumnRenderer.component';
import AgGrid from '../../shared/agGrid/agGrid.component';
import { importValidationColumnDefinition, adminColumnSharedFields } from '../../shared/columnDefinitions';
import columnDefinitions from '../../shared/columnDefinitions/chartOfAccounts';

const adminColumn = {
  field: 'chartName',
  cellRenderer: ChartOfAccountsAdminColumnRenderer,
  ...adminColumnSharedFields,
};

class ChartOfAccountsGrid extends PureComponent {
  static propTypes = {
    chartAccounts: ChartAccountsPropTypes,
    shouldDisplayAdminColumn: PropTypes.bool.isRequired,
    componentToRenderOnSearchBar: PropTypes.node,
    messageToRenderOnSearchBar: PropTypes.node,
    chartAccountsLoading: PropTypes.bool.isRequired,
  };

  onRowDataUpdated = ({ gridApi }) => {
    if (gridApi) {
      gridApi.applyColumnState({
        state: [
          { colId: importValidationColumnDefinition.field, sort: 'desc' },
        ],
      });
    }
  };

  render() {
    const {
      chartAccounts,
      shouldDisplayAdminColumn,
      componentToRenderOnSearchBar,
      messageToRenderOnSearchBar,
      chartAccountsLoading,
    } = this.props;

    const hasImportValidationsErrors = chartAccounts.some(chartAccounts => chartAccounts.importStatusDetail === -1);

    let modifiedColumnDefs = columnDefinitions;
    modifiedColumnDefs = hasImportValidationsErrors ? [importValidationColumnDefinition].concat(modifiedColumnDefs)
      : modifiedColumnDefs;
    modifiedColumnDefs = shouldDisplayAdminColumn ? [adminColumn].concat(modifiedColumnDefs) : modifiedColumnDefs;

    return (
      <div className="ag-grid-full-page-with-secondary-menu">
        <AgGrid
          componentToRenderOnSearchBar={componentToRenderOnSearchBar}
          messageToRenderOnSearchBar={messageToRenderOnSearchBar}
          columnDefs={modifiedColumnDefs}
          rowData={chartAccounts}
          withSearchBar
          isGridLoading={chartAccountsLoading}
          onRowDataUpdated={this.onRowDataUpdated}
        />
      </div>
    );
  }
}

export default ChartOfAccountsGrid;
